import {
  UPDATE_REMARKS_DATA_SOURCE
} from './dv2Actions';

const initialState = { remarkDataSource: ['Pass', 'Fail', 'Cheat'] };

function challengeScoreRoot (state = initialState, action) {
  switch (action.type) {
    case UPDATE_REMARKS_DATA_SOURCE:
      return { ...state, remarkDataSource: action.remarkDataSource };

    default:
      return state;
  }
}

export default challengeScoreRoot;
